<template>
  <div id="lists-select-modal">
    <!-- Edit post modal -->
    <div class="post-modal">
      <div class="post-modal-content">
        <div class="post-modal-header">
          <a @click="closeListsSelectModal" class="close"><i class="far fa-times"></i></a>
          <p class="lead">Add to Lists</p>
        </div><!-- /. post-modal-header -->
        <div class="post-modal-body">
          <!-- Show your lists -->
          <table class="table" v-if="lists.length">
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in lists">
                <td>{{ list.title }}</td>
                <td>
                  <button class="btn btn-primary btn-sm" @click="selectList(fullPost, list)" v-if="isInList(fullPost.id, list) == false">Select</button>
                  <button class="btn btn-danger btn-sm" @click="removeFromList(fullPost, list)" v-if="isInList(fullPost.id, list) == true">Remove</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            <div class="card">
              <div class="card-body">
                <p class="card-text">You have not created any lists yet.</p>
              </div><!-- /.card-body -->
            </div><!-- /.card -->
          </div> <!-- v-else -->


        </div><!-- /.post-modal-body -->
        <div class="post-modal-footer">
          <div class="float-right">
            <button @click="closeListsSelectModal" class="btn btn-secondary">Close</button>
          </div><!-- /.float-right -->
        </div><!-- /.post-modal-footer -->
      </div><!-- /.post-modal-content -->
    </div><!-- /.post-modal -->
  </div><!-- /#lists-select-modal -->
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  const fb = require('../firebaseConfig.js')

  export default {
    props: ['fullPost'],
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser', 'posts', 'lists'])
    },
    methods: {
      closeListsSelectModal() {
        this.$emit('closeListsSelectModal')
      },
      selectList(post, list) {
        console.log(post)
        // Build the list posts array
        var listPostsArray = []
        for (var i = 0; i < list.posts.length; i++) {
          listPostsArray.push(list.posts[i])
        }
        listPostsArray.push({ id: post.id })
        fb.listsCollection.doc(list.id).update({
          posts: listPostsArray
        }).then(ref => {
        }).catch(err => {
          console.log(err)
        })
      },
      removeFromList(post, list) {
        // Build the list posts array
        var listPostsArray = []
        for (var i = 0; i < list.posts.length; i++) {
          if (list.posts[i].id == post.id) {
          } else {
            listPostsArray.push(list.posts[i])
          }
        }
        fb.listsCollection.doc(list.id).update({
          posts: listPostsArray
        }).then(ref => {
        }).catch(err => {
          console.log(err)
        })
      },
      isInList(postId, list) {
        for (var i = 0; i < list.posts.length; i++) {
          if (postId == list.posts[i].id) {
            return true
          }
        }
        return false
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          let regex = /(<([^>]+)>)/ig;
          let cleanVal = val.replace(regex, " ");
          return cleanVal
         }
        let regex = /(<([^>]+)>)/ig;
        let cleanVal = val.replace(regex, " ");
        return `${cleanVal.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ListsSelectModal.vue